<template>
  <page name="DevicePage">
    <x-nav slot="header">Device</x-nav>
    
    <a @click="$root.goto('InducteeDetailsPage', inductee.InducteeID)">
      <x-now-playing
      text="NOW PLAYING"
      :inductee="inductee"
      ></x-now-playing>
    </a>
    
    <div class="inductee_info">
      <div>Performer: {{ inductee.Performer }}</div>
      <div>Composer: {{ inductee.Composer }}</div>
      <div>Courtesy Of: {{ inductee.CourtesyOf }}</div>
      <div>
        <external-link v-if="hasBuyLink" class="buy-link" :href="inductee.BuyLink">BUY NOW</external-link>
        <span v-else class="no-buy-link">No "buy now" link</span>
      </div>
    </div>
    
    <x-footer slot="footer">
      <a class="button" @click="$root.goto('InducteePage')">
        <img src="img/addcircle_icon.png" class="button-icon">Explore and Listen</span>
      </a>
    </x-footer>
  </page>
</template>

<script>
export default {
  components: {
    'page': require('./Page.vue'),
    'x-nav': require('./Nav.vue'),
    'x-footer': require('./Footer.vue'),
    'x-now-playing': require('./NowPlaying.vue'),
  },
  computed: {
    inductee () {
      return this.$root.nowPlaying('device')
    },
    hasBuyLink () {
      return this.inductee.BuyLink && this.inductee.BuyLink !== ""
    }
  }
}
</script>

<style>
  .buy-link,
  .buy-link:visited {
    color: white;
  }
  .no-buy-link {
    color: gray;
  }
</style>